import MenuIcon from '@mui/icons-material/Menu'
import { Box, Button, Stack, Paper, Typography } from '@mui/material'
import { ReactNode, useState } from 'react'

import Error from '~/components/error'
import UpgradeWrapper from '~/components/upgradeWrapper'
import useUserAccess from '~/features/auth/hooks/useUserAccess'
import useGetOrganization from '~/features/organizations/hooks/useGetOrganization'
import { scenariosSideNavWidthInPixels } from '~/layouts/account/scenariosLayout/constants'
import ScenariosSideNav from '~/layouts/account/scenariosLayout/scenariosSideNav'
import { store } from '~/store'
import rem from '~/utils/ui'

function ScenariosLayout({ children }: { children: ReactNode | ReactNode[] }) {
  const [mobileSideNavOpen, setMobileSideNavOpen] = useState(false)

  const organizationId = store((state) => state.user.organizationId)
  const { isLoading, isError } = useGetOrganization(organizationId)

  const { isPlusUser } = useUserAccess()

  if (!isPlusUser)
    return (
      <Paper
        sx={{
          paddingBlock: { xxxs: 1, sm: 2, md: 4 },
          paddingInline: { xxxs: 1, sm: 2, md: 4 },
        }}
      >
        <UpgradeWrapper shouldBelongToPlusPlan isMarkingPaidFeature>
          <Typography>
            You can now define simple to complex scenarios that your assistant
            can handle throughout the course of a conversation. The Scenario
            Builder allows you to define structured workflows that your AI
            assistant can follow, integrating seamlessly with your business
            systems to do things like book, cancel, and reschedule appointments,
            get customer info, and more. This capability is available for Plus
            subscribers.
          </Typography>
        </UpgradeWrapper>
      </Paper>
    )

  if (isError && !isLoading) {
    return <Error message="Something went wrong. Please try again later" />
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <ScenariosSideNav
        mobileOpen={mobileSideNavOpen}
        setMobileOpen={setMobileSideNavOpen}
      />
      <Stack sx={{ pl: { md: rem(scenariosSideNavWidthInPixels) } }} gap={2}>
        <Button
          onClick={() => setMobileSideNavOpen(!mobileSideNavOpen)}
          variant="secondary"
          startIcon={<MenuIcon />}
          sx={{ display: { md: 'none' } }}
        >
          Scenarios and Actions
        </Button>
        <Box>{children}</Box>
      </Stack>
    </Box>
  )
}

export default ScenariosLayout
